<template>
    <div class="background_color_web">
        <div class="container padding-top-20 padding-bottom-20">
            <LookupPower/>
        </div>
    </div>
</template>

<script>
    import LookupPower from "@/components/dictionary/lookup/LookupPower"

    export default {
        name: 'LookupView',
        components: {
            LookupPower
        },
        props: {},
        data: function () {
            return {}
        },
        mounted() {
            // this.wordText = this.$route.query['word']
        }
    }
</script>
